module.exports = __webpack_public_path__ + "img/Avatar-60.ce3a66bd.svg";